module.exports = __webpack_public_path__ + "img/7@2x-zh.957fec73.png";